export default __webpack_public_path__ + "static/media/ic-instruction-07.4c94f143.svg";